import { render, staticRenderFns } from "./MessageItemHeader.vue?vue&type=template&id=7033c3f6&scoped=true&"
import script from "./MessageItemHeader.vue?vue&type=script&lang=ts&"
export * from "./MessageItemHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033c3f6",
  null
  
)

export default component.exports